import React, { useEffect } from "react";
import { FTPCheckBox, FTPInput, FTPSelect } from "../components-new";
import { DeleteButton } from "../features/task-manager/task-list-components/Buttons";
import CategoryWise from "./cat-wise-sub-question";

const QUESTION_TYPE = [
  "input",
  "number-input",
  "date-input",
  "single-select",
  "single-select-other",
  "multi-select",
  "multi-select-other",
  "dropdown",
];
const INPUT_FIELD_TYPE = ["input", "number-input", "date-input"];
const OPTION_TYPES = [
  "single-select",
  "single-select-other",
  "multi-select",
  "multi-select-other",
  "dropdown",
];
const OPTION_TYPES_FOR_OTHER_TEXT_BOX = [
  "single-select-other",
  "multi-select-other",
];
const SubQuestion = ({
  field,
  sectionIndex,
  index,
  methods,
  languages,
  remove,
}) => {
  const fieldType = methods.watch(
    `payload.sections.${sectionIndex}.fields.${index}.field_type`
  );
  const showOptions = OPTION_TYPES.includes(fieldType);
  const showOtherText = OPTION_TYPES_FOR_OTHER_TEXT_BOX.includes(fieldType);
  const showCatOptions = fieldType.includes("cat-wise")

  useEffect(() => {
    if (INPUT_FIELD_TYPE.includes(fieldType)) {
      languages.map((lng) => {
        methods.setValue(
          `payload.sections.${sectionIndex}.fields.${index}.options.${lng}`,
          " "
        );
      });
    } else {
      languages.map((lng) => {
        const current_value = methods.getValues(
          `payload.sections.${sectionIndex}.fields.${index}.options.${lng}`
        );
        if (current_value && Array.isArray(current_value)) {
          methods.setValue(
            `payload.sections.${sectionIndex}.fields.${index}.options.${lng}`,
            current_value.join("\n")
          );
        }

      });
    }
  }, [fieldType]);
  return (
    <div key={field.id}>
      <h1>Sub Question {index + 1}</h1>

      <FTPInput
        label="Question Key"
        name={`payload.sections.${sectionIndex}.fields.${index}.key`}
      />

      <h3>Question Texts</h3>
      <div className="grid grid-cols-2 gap-2">
        {languages.map((lng) => (
          <FTPInput
            key={lng}
            multiline
            rows={3}
            label={lng.toUpperCase()}
            name={`payload.sections.${sectionIndex}.fields.${index}.name.${lng}`}
          />
        ))}
      </div>

      <FTPSelect
        label="Type"
        name={`payload.sections.${sectionIndex}.fields.${index}.field_type`}
        options={QUESTION_TYPE}
      />
      {/* {showCatOptions && <div >
        <h3>Category Options</h3> */}
      {/* <div className="grid grid-cols-2 gap-2">
          {languages.map((lng) => (
            <FTPInput
              key={lng}
              multiline
              rows={10}
              label={lng.toUpperCase()}
              name={`payload.sections.${sectionIndex}.fields.${index}.options.${lng}`}
            />
          ))}
        </div> */}
      {/* <CategoryWise index={index} languages={languages} methods={methods} sectionIndex={sectionIndex} />
      </div>} */}
      {/* ALWAYS RENDER — just hide when not needed */}
      <div style={{ display: showOptions ? "block" : "none" }}>
        <h3>Options</h3>
        <div className="grid grid-cols-2 gap-2">
          {languages.map((lng) => (
            <FTPInput
              key={lng}
              multiline
              rows={10}
              label={lng.toUpperCase()}
              name={`payload.sections.${sectionIndex}.fields.${index}.options.${lng}`}
            />
          ))}
        </div>
      </div>

      {/* SAME APPROACH FOR OTHER TEXT */}
      <div style={{ display: showOtherText ? "block" : "none" }}>
        <h3>Other Text</h3>
        <div className="grid grid-cols-2 gap-2">
          {languages.map((lng) => (
            <FTPInput
              key={lng}
              label={lng.toUpperCase()}
              name={`payload.sections.${sectionIndex}.fields.${index}.other_text.${lng}`}
            />
          ))}
        </div>
      </div>

      <FTPCheckBox
        label="Validated"
        name={`payload.sections.${sectionIndex}.fields.${index}.validation`}
      />
      {index > 0 && (
        <DeleteButton
          text="Remove Sub Question"
          onClick={() => remove(index)}
        />
      )}
    </div>
  );
};

export default SubQuestion;
